module.exports = __webpack_public_path__ + "img/banner_doctor_coop.e714fafb.png";